exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-wrapper[data-v-6b67701c]{padding:12px 0;font-size:.9em\n}\n.date[data-v-6b67701c]{font-weight:300;font-size:.85em;display:inline-block;padding-right:24px;float:right\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b67701c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/Notification.vue
// module id = Aq1M
// module chunks = 1